import util from '@bmp-vue/core/api/util'

const controller = 'ProjetoChecklist'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetByIdPortal: function (codigoPortal) {
    return util.Axios.Get(controller + '/GetByIdPortal', codigoPortal)
  }
})
